/**
 * @file The RepeatSplitFormComponent is used split in repeat in 2.
 * The form is activated with an action button and displayed in the overlay.
 * @author Tom Verschoore de la Houssaije
 */
import * as tslib_1 from "tslib";
import { OnDestroy } from '@angular/core';
import { AlertsService } from '../../core/alerts.service';
import { OverlayService } from '../../core/overlay.service';
import { OverlayProvider } from '../../ui/overlay-provider';
import { DomainService } from '../../domain.service';
import * as moment from 'moment';
import { Router } from '@angular/router';
import { RepeatValidation } from '../helpers/repeat-validation';
import { TranslateService } from '@ngx-translate/core';
import { SettingsService } from '../../settings.service';
import { BackendSettingsService } from '../../backend-settings.service';
import { AbstractBase } from '../../core/helpers/abstract-base';
/**
 * The RepeatSplitFormComponent is used split in repeat in 2.
 * The form is activated with an action button and displayed in the overlay.
 *
 * @export
 * @class RepeatSplitFormComponent
 * @implements {OnDestroy}
 */
var RepeatSplitFormComponent = /** @class */ (function (_super) {
    tslib_1.__extends(RepeatSplitFormComponent, _super);
    /**
     * Creates an instance of RepeatSplitFormComponent.
     * @param {DomainService} domainService To communicate with the backend.
     * @param {SettingsService} settingsService Contains settings.
     * @param {AlertsService} alertsService  To show feedback messages to the user.
     * @param {OverlayService} overlayService The service that manage the overlay of the application.
     * @param {Router} router The service that manage application routing.
     * @param {OverlayProvider} overlayProvider To provide the needed create parameters.
     * @param {SettingsService} settingsService To provide application settings parameter values.
     */
    function RepeatSplitFormComponent(domainService, settingsService, backendSettingsService, alertsService, overlayService, router, translateService, overlayProvider) {
        var _this = _super.call(this) || this;
        _this.domainService = domainService;
        _this.settingsService = settingsService;
        _this.backendSettingsService = backendSettingsService;
        _this.alertsService = alertsService;
        _this.overlayService = overlayService;
        _this.router = router;
        _this.translateService = translateService;
        /**
         * A list of validation errors
         */
        _this.validationErrors = [];
        _this.originalToSplit = overlayProvider.entity;
        if (!_this.originalToSplit) {
            throw Error('There is no entity to split in RepeatSplitFormComponent.');
        }
        if (_this.originalToSplit.entityType.shortName === 'PlanItem') {
            _this.originalToSplit = _this.originalToSplit['Item'];
            if (!_this.originalToSplit) {
                throw Error('PlanItem has no entity to split in RepeatSplitFormComponent.');
            }
        }
        _this.originalRepeat = _this.originalToSplit['RepeatPattern'];
        if (!_this.originalRepeat) {
            throw Error('Repeat is missing in RepeatSplitFormComponent.');
        }
        // Set split date.
        // We hebben nu nog alleen Availability --> case switch wanneer we meer gaan doen?
        _this.splitDate = _this.backendSettingsService.availabilityClosedTill.clone();
        var originalStart = moment(_this.originalToSplit['Start']);
        var duration = moment(_this.originalToSplit['Finish']).diff(originalStart);
        var newStart = moment(_this.splitDate);
        // Workaround moment.js weekday bug.
        // De week dag zetten, met moment.js, ging fout bij een originalStart van 31-03-2017 00:00
        // Oude code:
        // newStart.weekday(originalStart.weekday());
        // Nieuwe workaround code
        var originalWeekDay = originalStart.toDate().getDay();
        var test = newStart.toDate().getDay();
        while (test !== originalWeekDay) {
            // Ik zorg hiermee nu ook er voor dat ik altijd vooruit ga verder weg van this.splitDate.
            // Zodat ik niet terug ga naar weekdag van de this.splitDate week.
            newStart = newStart.add(1, 'days');
            test = newStart.toDate().getDay();
        }
        newStart = newStart.hours(originalStart.hours());
        newStart = newStart.minutes(originalStart.minutes());
        if (newStart.isSame(originalStart)) {
            // Als je wil splitsen kies je altijd een andere dag.
            newStart = newStart.add(7, 'days');
        }
        // Set split enitity.
        _this.splitEntity = _this.domainService.copy(_this.originalToSplit, true);
        _this.splitEntity['Start'] = newStart.toDate();
        _this.splitEntity['Finish'] = newStart.add(duration).toDate();
        // Set and start with rendering configuration.
        _this.formConfiguration = overlayProvider.configuration;
        return _this;
    }
    Object.defineProperty(RepeatSplitFormComponent.prototype, "entityOid", {
        /**
         * Gets the Oid of the new entity.
         * @readonly
         * @type {string}
         */
        get: function () {
            if (!this.splitEntity) {
                return null;
            }
            return this.splitEntity['Oid'];
        },
        enumerable: true,
        configurable: true
    });
    /**
     *  Lifecycle hook that is called when the component is destroyed.
     */
    RepeatSplitFormComponent.prototype.ngOnDestroy = function () {
        if (this.splitEntity && this.splitEntity.entityAspect.entityState.isAdded()) {
            // Cleanup the created entity bacause the split is cancelled.
            this.splitEntity.entityAspect.rejectChanges();
        }
    };
    /**
     * Returns a value indicating whether the entity can be split.
     */
    RepeatSplitFormComponent.prototype.canSave = function () {
        if (!this.splitDate) {
            return false;
        }
        // Wens van WJ https://github.com/Symagic/html5/issues/1051#issuecomment-391649312
        // Start moet na of op het Split-tijdstip liggen -> Wordt: Start datum moet na of op het Split datum liggen
        var dateOfStart = this.splitEntity['Start'];
        dateOfStart = new Date(dateOfStart.getFullYear(), dateOfStart.getMonth(), dateOfStart.getDate());
        return !this.splitDate.isAfter(dateOfStart) && this.originalToSplit['Start'] < dateOfStart;
    };
    /**
     * Cancels the request and closes the overlay.
     */
    RepeatSplitFormComponent.prototype.cancelItem = function () {
        if (this.splitEntity) {
            this.splitEntity.entityAspect.rejectChanges();
        }
        this.overlayService.closeOverlay();
    };
    /**
     * Saves the new created reassign request when valid.
     *
     * @param {any} event The click event that triggered the method.
     * @returns void
     */
    RepeatSplitFormComponent.prototype.saveItem = function (event) {
        var _this = this;
        // this.validationErrors.splice(0, this.validationErrors.length);
        this.validationErrors.length = 0;
        var splitUntil = this.calculateSplitUntilDate();
        if (splitUntil === undefined) {
            this.validationErrors.push('APP.DOMAIN.VALIDATORS.ENDLESS_LOOP_CALCULATING_SPLIT_UNTIL');
            return;
        }
        if (splitUntil == null) {
            this.validationErrors.push('APP.DOMAIN.VALIDATORS.SPLIT_UNTIL_BEFORE_START');
            return false;
        }
        var originalStart = this.originalToSplit['Start'];
        var originalFinish = this.originalToSplit['Finish'];
        var effectiveFinish = originalFinish;
        if (splitUntil.getUTCFullYear() < 9999) {
            effectiveFinish = new Date(splitUntil.getTime()
                + originalStart.getHours() * 3600000
                + originalStart.getMinutes() * 60000
                + originalStart.getSeconds() * 1000 // Should be zero, I'm trying to be sure.
                + originalFinish.getTime()
                - originalStart.getTime());
        }
        var currentFinish = this.splitEntity['Finish'];
        if (effectiveFinish > currentFinish) {
            this.validationErrors.push('APP.DOMAIN.VALIDATORS.SPLIT_FINISH_AFTER_FINISH');
            return false;
        }
        if (event) {
            event.target.classList.add('sym-working');
        }
        // Was eerst:
        // this.originalRepeat.UntilDate = this.calculateSplitUntilDate();
        this.originalRepeat.UntilDate = splitUntil; // Maar waarom nog een keer uitrekenen?
        if (splitUntil.getUTCFullYear() === 9999 || splitUntil.getTime() === originalStart.getTime()) {
            // calculateSplitUntilDate returns infinite date when UntilDate is before Start.
            // That is why:
            this.originalRepeat.Kind = 'ONCE';
        }
        this.originalRepeat['@ValidatedRepeatSplit'] = true;
        this.subscriptionPool.add(this.domainService.saveChanges(function (error) {
            // Remove sym-working to show that action is finished.
            if (event) {
                event.target.classList.remove('sym-working');
            }
            // Give correct alert based on whether an error is given or not.
            if (error) {
                if (error instanceof Array) {
                    _this.validationErrors = error;
                    return;
                }
                if (error.entityErrors && error.entityErrors.length > 0) {
                    _this.validationErrors = [];
                    error.entityErrors.forEach(function (err) {
                        _this.subscriptionPool.add(_this.translateService.get(err.errorName).subscribe(function (value) {
                            if (value === err.errorName) {
                                _this.validationErrors.push(err.errorMessage ? err.errorMessage : 'Error ' + err.errorName +
                                    ' ' + err.entity.entityType.shortName + '.' + err.propertyName);
                            }
                            else {
                                _this.validationErrors.push(err.errorName);
                            }
                        }));
                    });
                    return;
                }
                _this.alertsService.createAlert('warning', 'APP.FORMS.ITEMS_UNSUCCESSFULLY_SAVED', _this.domainService.entityErrorInfo(error.entityErrors));
            }
            else {
                _this.alertsService.createAlert('success', 'APP.FORMS.ITEMS_SUCCESSFULLY_SAVED');
                _this.overlayService.closeOverlay();
            }
        }, this.formConfiguration.data).subscribe(function (result) {
            var path = _this.router.url;
            var i = path.lastIndexOf('/');
            _this.navigateBackFromNew(_this.splitEntity, path.substr(0, i));
        }));
    };
    /**
     * Calculates until date to stop splitting repeat.
     * Until date is before new start and has a match with the splitting repeat pattern.
     * @private
     * @returns {Date} The splitting until date.
     */
    RepeatSplitFormComponent.prototype.calculateSplitUntilDate = function () {
        var tries = 65;
        var splitUntil = this.splitEntity['Start'];
        splitUntil = new Date(splitUntil.getFullYear(), splitUntil.getMonth(), splitUntil.getDate());
        splitUntil = new Date(splitUntil.getTime() - 86400000); // Go one day backward.
        var untilValidation = this.originalRepeat.validateWith(splitUntil, false);
        while (untilValidation !== RepeatValidation.Ok) {
            tries--;
            if (tries < 0) {
                // Stop from endless loop.
                return undefined;
            }
            var year = splitUntil.getFullYear();
            switch (untilValidation) {
                case RepeatValidation.UntilDateBeforeStart:
                    // Original Repeat Will become ONCE.
                    return new Date(Date.UTC(9999, 11, 30, 23));
                case RepeatValidation.OccurrenceOrderMismatch:
                case RepeatValidation.WeekDayMismatch:
                    // Go one day backward.
                    splitUntil = new Date(splitUntil.getTime() - 86400000);
                    untilValidation = this.originalRepeat.validateWith(splitUntil, false);
                    break;
                case RepeatValidation.DateMismatch:
                    var month = splitUntil.getMonth();
                    var date = Number.parseInt(this.originalRepeat.Days);
                    if (date > splitUntil.getDate()) {
                        month--; // We go backward.
                    }
                    if (month < 0) {
                        month = 11; // We go backward
                        year--;
                    }
                    // Go backward to intended date
                    splitUntil = new Date(year, month, date);
                    if (month !== splitUntil.getMonth()) {
                        splitUntil = new Date(year, month + 1, 1);
                        splitUntil.setTime(splitUntil.getTime() - 86400000);
                    }
                    untilValidation = this.originalRepeat.validateWith(splitUntil, false);
                    break;
                case RepeatValidation.MonthMismatch:
                    year = splitUntil.getFullYear();
                    if (this.originalRepeat.Factor - 1 > splitUntil.getMonth()) {
                        year--; // We go backward.
                    }
                    // Go backward to intended month
                    splitUntil = new Date(year, this.originalRepeat.Factor - 1, splitUntil.getDate());
                    untilValidation = this.originalRepeat.validateWith(splitUntil, false);
                    break;
            }
        }
        // Wens van WJ https://github.com/Symagic/html5/issues/999#issuecomment-389877101
        var dateOfStart = this.originalToSplit['Start'];
        dateOfStart = new Date(dateOfStart.getFullYear(), dateOfStart.getMonth(), dateOfStart.getDate());
        if (splitUntil < dateOfStart) {
            return null;
        }
        return splitUntil;
    };
    /**
     * Notifies the main view of a entity creation.
     * @private
     * @param {Entity} item The entity created.
     * @param {string} path The current path root.
     */
    RepeatSplitFormComponent.prototype.navigateBackFromNew = function (item, path) {
        var id = '';
        item.entityType.keyProperties.forEach(function (property) {
            id += '_' + item[property.name];
        });
        id = id.substring(1);
        this.router.navigate([path], { queryParams: { 'new-result': id } });
    };
    return RepeatSplitFormComponent;
}(AbstractBase));
export { RepeatSplitFormComponent };
